export const CERCLES_PAIENS_TRANSITION = new Date("2026-11-01T00:00:00+01:00");

const editorialNow = () => {
  if (typeof window === "undefined") return new Date();
  const isPreview = window.location.hostname.endsWith(".preview.emergentagent.com");
  const forcedDate = isPreview && new URLSearchParams(window.location.search).get("cercles-paiens-preview-date");
  const parsedDate = forcedDate && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d{2}$/.test(forcedDate) ? new Date(forcedDate) : null;
  return parsedDate && !Number.isNaN(parsedDate.valueOf()) ? parsedDate : new Date();
};

export const isCerclesPaiensLive = (date = editorialNow()) => date >= CERCLES_PAIENS_TRANSITION;

export const isPaganCircle = (event) => (
  event?.type === "cercle"
  && !event.cercle_debutants
  && !event.reserve_parcours
  && new Date(event.date) >= CERCLES_PAIENS_TRANSITION
);

const celebrationName = (title = "") => {
  const normalized = title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  return ["yule", "imbolc", "ostara", "beltaine"].find((name) => normalized.includes(name)) || null;
};

export const paganCircleTitle = (event, locale = "fr", active = isCerclesPaiensLive()) => {
  if (!active || !isPaganCircle(event)) return event?.titre || "";
  const celebration = celebrationName(event.titre);
  if (locale === "en") {
    if (celebration) return `Pagan Circle — Ritual Celebration of ${celebration[0].toUpperCase()}${celebration.slice(1)}`;
    return `Pagan Circle — ${event.titre.replace(/^Cercle de tambours\s*[—-]\s*/i, "")}`;
  }
  if (celebration) return `Cercle Païen — Célébration rituelle de ${celebration[0].toUpperCase()}${celebration.slice(1)}`;
  return `Cercle Païen — ${event.titre.replace(/^Cercle de tambours\s*[—-]\s*/i, "")}`;
};

export const paganCircleBadge = (event, locale = "fr", active = isCerclesPaiensLive()) => {
  if (!isPaganCircle(event)) return null;
  if (active) return locale === "en" ? "Pagan Circle · Public ritual" : "Cercle Païen · Rituel public";
  return locale === "en" ? "Pagan Circles · from 1 November 2026" : "Cercles Païens · dès le 1er novembre 2026";
};

export const circleTypeLabel = (event, locale = "fr", active = isCerclesPaiensLive()) => {
  if (event?.cercle_debutants) return locale === "en" ? "Beginner drum circle" : "Cercle de tambours débutants";
  if (isPaganCircle(event)) return active ? (locale === "en" ? "Pagan Circle" : "Cercle Païen") : (locale === "en" ? "Ritual circle" : "Cercle rituel");
  return locale === "en" ? "Drum circle" : "Cercle de tambours";
};

export const circleNavLabel = (locale = "fr", active = isCerclesPaiensLive()) => active
  ? (locale === "en" ? "Pagan Circles" : "Cercles Païens")
  : (locale === "en" ? "Pagan Circles · from 1 Nov" : "Cercles Païens · dès le 1er nov.");